import { eventKeyConstants } from './eventKey';

export const menuListHelper = (menuName: string, event: any,closeMenu: any) => {
    const refElem = document.getElementById(`submenu-${menuName}`);
    const menuItems = refElem.querySelectorAll('*[role="menuitem"]');
    let currIndex: any = getCurrIndex(menuItems);
    let currItem: any = menuItems[currIndex];

    switch (event.key) {
        case eventKeyConstants.ENTER:
        case eventKeyConstants.SPACE:
             event.stopPropagation();
             event.preventDefault();
             closeMenu('');
             break;  
        case eventKeyConstants.ARROWDOWN:

            event.stopPropagation();
            event.preventDefault();
            if (currItem == menuItems[menuItems.length - 1]) {
                currItem = menuItems[0];
                currIndex = 0;
            }
            else {
                const nextIndex = currIndex + 1;
                currItem = menuItems[nextIndex];
            }
            currItem.focus();
            break;
        case eventKeyConstants.ARROWUP:

            event.stopPropagation();
            event.preventDefault();
            if (currItem == menuItems[0]) {
                currItem = menuItems[menuItems.length - 1];
                currIndex = menuItems.length - 1;
            }
            else {
                const prevIndex = currIndex - 1;
                currItem = menuItems[prevIndex];
            }
            currItem.focus();
            break;
        case eventKeyConstants.HOME:
            event.preventDefault();
            event.stopPropagation();
            (menuItems[0] as HTMLElement).focus();
            break;
        case eventKeyConstants.END:
            event.preventDefault();
            event.stopPropagation();
            (menuItems[menuItems.length - 1] as HTMLElement).focus();
            break;
        default:
            // not to prevent synthetic events for other keys
            break;
    }
}
const getCurrIndex = (menuItems) => {

    let currIndex = 0;
    menuItems.forEach((el, index) => {
        if (el == document.activeElement) {
            currIndex = index;
        }
    })
    return currIndex;
}

